import { useState, useEffect } from 'react';

// Global cache for animation data to avoid repeated fetches
let animationDataCache = null;
let animationDataPromise = null;

const useLottieAnimation = () => {
  const [animationData, setAnimationData] = useState(animationDataCache);
  const [isLoading, setIsLoading] = useState(!animationDataCache);
  const [error, setError] = useState(null);

  useEffect(() => {
    // If we already have the data, no need to fetch
    if (animationDataCache) {
      setAnimationData(animationDataCache);
      setIsLoading(false);
      return;
    }

    // If there's already a fetch in progress, wait for it
    if (animationDataPromise) {
      animationDataPromise
        .then((data) => {
          setAnimationData(data);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err);
          setIsLoading(false);
        });
      return;
    }

    // Start new fetch
    setIsLoading(true);
    setError(null);

    animationDataPromise = fetch('/static/animations/loader.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load animation: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        animationDataCache = data;
        animationDataPromise = null;
        setAnimationData(data);
        setIsLoading(false);
        return data;
      })
      .catch((err) => {
        setError(err);
        animationDataPromise = null;
        setIsLoading(false);
      });
  }, []);

  return { animationData, isLoading, error };
};

export default useLottieAnimation;
